<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <!--
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            -->
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="online-players-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          > <!-- REMOVED v-model="copy" -->

            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(eshop_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(surname)="data">{{ $t(data.label) }}</template>
            <!--
            <template v-slot:head(cnp)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(blacklisted)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(app_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(euser_id)="data">{{ $t(data.label) }}</template>

            <template v-slot:cell(euser_id)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/users/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>
            <template v-slot:cell(app_id)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>
            -->
            <template v-slot:head(email)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(winner_external_id)="data">{{ $t(data.label) }}</template>

            <!--
            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
            -->
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <!--
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                -->
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'online-players-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import tableMixin from "@/shared/mixins/table.mixin";
import DropdownColumns from "@/components/DropdownColumns";
// import TableFilters from "@/components/TableFilters";
// import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  name: "onlinePlayers",
  components: {
    PaginationSelect,
    DropdownColumns,
    // BulkActionSelect,
    // TableFilters
  },
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "onlinePlayersTable",

      /*
      bulkAction: null,
      bulkActionOptions: [
        {
          text: "Blacklist Players",
          field: "blacklisted",
          value: true
        },
        {
          text: "Allow Players",
          field: "blacklisted",
          value: false
        }
      ],

      filterOptions: [
        {
          field: "blacklisted",
          multiple: false,
          placeholder: "Blacklisted",
          options: [
            { name: "Blacklisted Players", value: true },
            { name: "Allowed Players", value: false }
          ],
          selected: []
        }
      ],
      */

      isBusy: false,
      sortBy: "email",
      sortDesc: false,
      fields: [
        /*
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        */
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          ignore: true,
          class: ""
        },
        { key: "ethird_party_player_ids", label: "Third Party Players", sortable: true, class: "" },
        /*
        {
          key: "app_id",
          label: "App Used",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "euser_id",
          label: "Added by",
          sortable: true,
          ignore: true,
          class: ""
        }
        */
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      // filter: null,
      // filterField: null,

      // checkAll: false,
      // selected: [],
      // copy: null,

      // addLabel: "Add online player"
    };
  },
  /*
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  */
  methods: {

    refresh() {
      this.$root.$emit("bv::refresh::table", "online-players-table");
    },
    /*
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },

    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("player/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    */
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };
      /*
      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }
      */
      paginationData.likeValues = [];
      paginationData.likeFields = [];

      if (this.sortBy) {
        let sortBy = this.sortBy;
        // if (sortBy == "euser_id") sortBy = "user_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      /*
      this.filterOptions.forEach(item => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });
      */

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      /*
      const userByID = this.$store.getters["cache/userByID"];
      const terminalByAppID = this.$store.getters["cache/terminalByAppID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "users").catch(e => e),
        this.$store.dispatch("cache/fetch", "terminals").catch(e => e)
      ]).finally(() => {
      */
        this.$store
          .dispatch("onlinePlayer/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
          /*
            resp.data.rows.forEach((item, index) => {

              if (item.blacklisted) {
                resp.data.rows[index]["_cellVariants"] = {
                  blacklisted: "danger"
                };
              }

              if (item.euser_id) {
                const data = userByID(item.euser_id);
                if (data) {
                  item.euser_id = {
                    to: item.euser_id,
                    name: data.username
                  };
                } else {
                  item.euser_id = {
                    to: null,
                    name: item.euser_id
                  };
                }
              }

              if (item.app_id) {
                const data = terminalByAppID(item.app_id);
                if (data) {
                  item.app_id = {
                    to: data.eshop_id,
                    name: item.app_id
                  };
                } else {
                  item.app_id = {
                    to: null,
                    name: item.app_id
                  };
                }
              }
            });
          */
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      // });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/online-players/" + item.eid);
    },
    redirect() {
      this.$router.push("/online-players/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


